import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 会员卡类别
 */
const card = {

    /**
     * 会员卡系列
     */

    //会员卡信息
    cardList(){
        return axios.post(ipAddress.qi+'/admin/a1/user-role-xref/cardList',null,false)
    },

    //添加会员
    addCard(form){
        return axios.post(ipAddress.qi+'/admin/a1/user-role-xref/addNielloVIP',form,true)
    },

    //会员查询
    updateCard(form){
        return axios.post(ipAddress.qi+'/admin/a1/user-role-xref/page',form,true)
    },

    //修改会员
    updateUser(form){
        return axios.post(ipAddress.qi+'/admin/a1/user-role-xref/upToursTimeById',form,true)
    },

    //删除会员
    deleteUser(id){
        return axios.post(ipAddress.qi+'/admin/a1/user-role-xref/delById',QS.stringify({
            id:id
        }),false)
    }


}
export default card;


// WEBPACK FOOTER //
// ./src/js/card/card.js